export enum Path {
  ValidateOrder = '/',
  Link = '/link',
  ReviewAndPay = '/payment/',
  ValidateOrderFailure = '/error/',
  ProcessingPayment = '/processing-payment/',
  Confirmation = '/confirmation/',
}
